module.exports = __webpack_public_path__ + "img/img-5.8e0c457d.jpg";